module.exports = __webpack_public_path__ + "img/phone-call.5f60d3e7.svg";